<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت دریافت ها</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">دریافتها</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-light text-left"
                                            @click="onPrintClicked()"><i class="fa fa-print"></i>
                                    </button>
                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddreciptClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ ابتدای بازه گزارش</span>
                                    </div>
                                    <date-picker type="date" format="jYYYY/jMM/jDD" @input="onStartDatePicked"
                                                 :auto-submit="true"
                                                 ref="paystartDate" style="flex: 1">
                                        <slot>
                                            <input v-model="newpayRepstartDate"
                                                   class="form-control date-input flex-grow-1" readonly="true"
                                                   @click="toggleStartDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ انتهای بازه گزارش</span>
                                    </div>
                                    <date-picker type="date" format="jYYYY/jMM/jDD" @input="onEndDatePicked"
                                                 :auto-submit="true"
                                                 ref="payendDate" style="flex: 1">
                                        <slot>
                                            <input v-model="newpayRependDate"
                                                   class="form-control date-input flex-grow-1" readonly="true"
                                                   @click="toggleEndDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام قرارداد یا نام محصول یا نام مشتری یا شماره همراه مشتری را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else id="printMe">
                                    <div v-if="myrecipts.length===0">
                                        <p class="text-center mt-3">هیچ دریافتی ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>تاریخ دریافت</th>
                                                <th>مبلغ دریافت</th>
                                                <th>نوع دریافت</th>
                                                <th>نام محصول</th>
                                                <th>نام مشتری/سرمایه گذار</th>
                                                <th>توضیحات</th>
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in myrecipts">

                                                <td class="text-nowrap">{{it.fDate}}</td>
                                                <td class="text-nowrap">{{it.price.toLocaleString()}}</td>
                                                <td class="text-nowrap">{{it.paymentTypeName }}</td>
                                                <td class="text-nowrap">{{it.customerBuyId !== null ?
                                                    it.customerBuy.product.name :"---"}}
                                                </td>
                                                <td class="text-nowrap">{{it.customerBuyId !==null ?
                                                    it.customerBuy.customer.fullName : "سرمایه: " +
                                                    it.capital.fullName}}
                                                </td>
                                                <td class="text-nowrap">{{it.description}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>
                                                </td>

                                            </tr>
                                            <tr>
                                                <td rowspan="2">جمع :</td>
                                                <td rowspan="2">{{myrecipts.reduce( (acc, item) => { return acc +=
                                                    item.price; }, 0).toLocaleString()}}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="reciptMode === 'create'">ثبت دریافت</h1>
                        <h1 v-else>ویرایش دریافت</h1>
                    </div>

                    <div class="row mt-3 px-5" v-if="reciptMode === 'create' && projPay">
                        <div class="col-12 input-group round mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text">جستجو</span>
                            </div>
                            <input class="form-control" v-model="searchcustomerBuy" @input="searchingcustomer()"
                                   placeholder="حداقل 2 کاراکتر از نام محصول یا نام خانوادگی یا شماره موبایل مشتری را وارد کنید">
                        </div>
                        <div class="col-12 overflow-auto" style="max-height: 12rem;">
                            <table class="table table-hover table-striped ">
                                <thead>
                                <tr>
                                    <th>نام محصول</th>
                                    <th>نام مشتری</th>
                                    <th>قیمت</th>
                                    <th>باقیمانده</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="it in customerBuys">

                                    <td class="clickable" @click="selectItem(it)">{{it.product.name}}</td>
                                    <td class="clickable" @click="selectItem(it)">{{it.customer.fullName}}</td>
                                    <td class="clickable" @click="selectItem(it)">{{it.price.toLocaleString()}}</td>
                                    <td class="clickable" @click="selectItem(it)">{{it.remain.toLocaleString()}}</td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row px-5" v-if="projPay">
                        <h4 class="col-12 text-center">قرارداد مشتری انتخاب شده</h4>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام محصول</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerBuyName">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مشتری</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerFullname">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">قیمت</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerBuyprice">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">باقیمانده</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerBuyremain">
                            </div>
                        </div>

                    </div>


                    <div class="row" v-if="checkPay">
                        <hr/>
                        <h4 class="col-12 text-center">مشخصات چک دریافتی</h4>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">بانک</span>
                                </div>
                                <input class="form-control" type="text" v-model="checkModel.bank">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شعبه</span>
                                </div>
                                <input class="form-control" type="text" v-model="checkModel.branch">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره حساب</span>
                                </div>
                                <input class="form-control" type="number" v-model="checkModel.accountNumber">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره چک</span>
                                </div>
                                <input class="form-control" type="number" v-model="checkModel.checkNumber">
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="checkModel.checkDescription">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ چک</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="oncheckDatePicked"
                                             :auto-submit="true"
                                             ref="checkDate" style="flex: 1">
                                    <slot>
                                        <input v-model="newcheckDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="togglecheckDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>

                    </div>

                    <hr/>
                    <div class="row px-5">
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">دریافت بابت</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="recType"
                                           :mode="'create'"
                                           :selected-val="preselectedRecFor"
                                           :header="{multiple: false, label: 'name'}"
                                           aria-placeholder="دریافت بابت"
                                           @onChange="onpayForChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-4 mb-2" v-if="contrPay">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کاربر</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="capitals"
                                           :mode="'create'"
                                           :selected-val="preselectedCapital"
                                           :header="{multiple: false, label: 'fullName'}"
                                           aria-placeholder="سرمایه گذار"
                                           @onChange="onCapitalChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-4 mb-2">
                            <div class="input-group round text-center d-block">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مبلغ دریافت</span>
                                    <input type="number" class="form-control" v-model="reciptModel.price"
                                           @input="thousandSeprator">
                                </div>
                                <small class="text-left">{{reciptModel.showprice}}</small>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نحوه دریافت</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="payType"
                                           :mode="'create'"
                                           :selected-val="preselectedResType"
                                           :header="{multiple: false, label: 'title'}"
                                           aria-placeholder="نحوه دریافت"
                                           @onChange="onpayTypeChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ دریافت</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked"
                                             :auto-submit="true"
                                             ref="startDate" style="flex: 1">
                                    <slot>
                                        <input v-model="newstartDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleCreateDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                        <div class="col-lg-8 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" v-model="reciptModel.description">
                            </div>
                        </div>

                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="updaterecipt" v-if="reciptMode=='edit'">ویرایش دریافت
                            </button>
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="createrecipt" v-else>ثبت دریافت
                            </button>
                            <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                    @click="cancelrecipt">انصراف
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import Vue from 'vue';


    export default {
        name: "recipts",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isSending: false,
                isLoading: false,
                myrecipts: [],

                reciptMode: "",
                reciptModel: {
                    id: 0,
                    price: 0,

                    date: "",
                    paymentType: 0,
                    description: "",
                    customerBuyId: 0,

                },
                newstartDate: "",
                newcheckDate: "",
                newendDate: "",
                search: "",
                searchId: "",

                customerBuys: [],
                customerBuyName: "",
                customerFullname: "",
                customerBuyprice: 0,
                customerBuyremain: 0,
                customerBuyId: 0,
                searchcustomerBuy: "",

                recType: [],
                //     {
                //         title: "فروش محصول",
                //         value: 1
                //     },
                //     {
                //         title: "آورده سرمایه گذار",
                //         value: 2
                //     }
                // ],
                payType: [],
                preselectedRecFor: "",
                capitals: [],
                preselectedCapital: {},

                preselectedResType: "",

                searchcontract: "",
                contracts: [],
                contractName: "",
                contractDis: "",
                contractId: 0,

                projPay: false,
                contrPay: false,
                checkPay: false,
                checkModel: {
                    bank: "",
                    branch: "",
                    accountNumber: 0,
                    checkNumber: 0,
                    checkDescription: "",
                    checkDate: "",
                },
                newpayRepstartDate: "",
                newpayRependDate: "",
                taxModel: {
                    startDate: "",
                    endDate: "",
                },


            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.searchId = this.$route.params.search;
            if (this.searchId !== undefined && this.searchId !== null && this.searchId !== '') {
                this.searchingId();
            } else {
                this.getMyrecipts();
            }
            this.getEnreciptType();
            this.getcapital();
            this.geyrecType();
        },
        methods: {
            geyrecType() {
                new BaseService("payReciptFor", "/GetReciptFor").getList().then(response => {
                    this.recType = response.data;
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            getEnreciptType() {
                new BaseService("Enum", "/GetEnPaymentType").getList().then(response => {
                    this.payType = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getcapital() {
                new BaseService("user", "/Getuser").getList().then(response => {
                    this.capitals = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            onpayTypeChange(val) {
                if (val && val.value !== undefined) {
                    if (val.value === 4) {
                        this.checkPay = true;
                    }
                    this.preselectedResType = val;
                    this.reciptModel.paymentType = val.value;
                    this.reciptModel.paymentTypeName = val.title;
                }
            },
            onpayForChange(val) {
                if (val && val.id !== undefined) {
                    this.preselectedRecFor = val;
                    if (val.userDependency === true) {
                        this.contrPay = true;
                    }
                    if (val.customerBuyDependency === true) {
                        this.projPay = true;
                    }
                    this.reciptModel.payReciptForId = val.id;
                }
            },

            onCapitalChange(val) {
                if (val && val.id !== undefined) {
                    this.preselectedCapital = val;

                    this.reciptModel.capitalId = val.id;
                }
            },

            getcustomerBuys() {
                new BaseService("customerBuy", "/GetRemainCustomerBuy").getList().then(response => {
                    this.customerBuys = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },


            onAddreciptClicked() {
                this.reciptModel = {
                    id: 0,
                    price: 0,
                    date: "2020-11-13T14:51:43.919Z",
                    paymentType: 0,
                    description: "",
                    customerBuyId: 0,
                };
                this.customerBuyName = "";
                this.customerFullname = "";
                this.newstartDate = "";
                this.customerBuyId = 0;
                this.getcustomerBuys();
                // this.getcontracts();
                this.getEnreciptType();
                this.reciptMode = "create";
                this.projPay = false;
                this.contrPay = false;
                this.preselectedRecFor = "";
                this.preselectedResType = "";
                this.preselectedCapital = {};
                this.$refs.insertModal.showModal();
            },
            getMyrecipts() {
                this.checkPay = false;
                new BaseService("recipt", "/Getrecipt").getList().then(response => {
                    this.myrecipts = response.data;
                    for (let it of this.myrecipts) {
                        it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        for (let j of this.payType) {
                            if (it.paymentType === j.value) {
                                it.paymentTypeName = j.title;
                            }
                        }
                    }
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getMyreciptsByDate() {
                this.checkPay = false;
                new BaseService("recipt", "/GetreciptByDate").create(this.taxModel).then(response => {
                    this.myrecipts = response.data;
                    for (let it of this.myrecipts) {
                        it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    }
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                if (item.customerBuyId !== null && item.customerBuyId !== 0) {
                    this.customerBuyName = item.customerBuy.product.name;
                    this.customerFullname = item.customerBuy.customer.fullName;
                    this.preselectedRecFor = "پروژه";
                    this.projPay = true;
                    this.contrPay = false;
                }
                this.reciptModel = item;
                this.reciptMode = "edit";
                if (item.date != null) {
                    this.newstartDate = Moment(this.gregorianToJalali(item.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                this.preselectedResType = item.paymentTypeName;

                this.getEnreciptType();
                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("recipt", "Deleterecipt").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMyrecipts();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updaterecipt() {
                this.isSending = true;
                // console.log(this.reciptModel);
                new BaseService("recipt", "/Updaterecipt").update(this.reciptModel).then(response => {
                    this.$noty.success("دریافت با موفقیت ویرایش شد");
                    this.$refs.insertModal.hideModal();
                    this.isSending = false;
                    this.getMyrecipts();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyrecipts();
                });

            },
            createrecipt() {
                console.log(this.reciptModel);
                if (this.reciptModel.paymentType === 0) {
                    Utils.handleErrorWithNotification("لطفا نحوه دریافت را انتخاب کنید", this.$noty);

                } else {
                    if (this.reciptModel.paymentType === 4) {
                        if (this.checkModel.bank === "") {
                            Utils.handleErrorWithNotification("لطفا بانک را وارد کنید", this.$noty);
                        } else if (this.checkModel.branch === "") {
                            Utils.handleErrorWithNotification("لطفا شعبه را وارد کنید", this.$noty);
                        } else if (this.checkModel.checkNumber === 0) {
                            Utils.handleErrorWithNotification("لطفا شماره چک را وارد کنید", this.$noty);
                        } else {
                            this.reciptModel.check = this.checkModel;
                        }
                    }
                    if (this.reciptModel.price == 0 || this.reciptModel.price == "") {
                        Utils.handleErrorWithNotification("لطفا مبلغ دریافتی را وارد کنید", this.$noty);
                    } else {
                        console.log(this.reciptModel);

                        if (this.projPay && this.reciptModel.customerBuyId === 0) {
                            Utils.handleErrorWithNotification("لطفا یک پروژه انتخاب کنید", this.$noty);
                        } else {
                            new BaseService("recipt", "/Createrecipt").create(this.reciptModel).then(response => {
                                this.$noty.success("دریافت با موفقیت ثبت شد");
                                this.$refs.insertModal.hideModal();
                                this.isSending = false;
                                this.reciptModel = {
                                    id: 0,
                                    price: 0,
                                    date: "",
                                    paymentType: 0,
                                    description: "",
                                    customerBuyId: 0,
                                    capitalId: 0,
                                };
                                this.getMyrecipts();
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data, this.$noty);
                                this.$refs.insertModal.hideModal();
                                this.getMyrecipts();
                            });
                        }
                    }
                }
                this.checkPay = false;
            },
            cancelrecipt() {
                this.projPay = false;
                this.contrPay = false;
                this.$refs.insertModal.hideModal();
                this.getMyrecipts();
            },
            onCreateDatePicked(val) {
                this.newstartDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.reciptModel.date = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateDatePicker() {
                this.$refs.startDate.togglePicker();
            },
            oncheckDatePicked(val) {
                this.newcheckDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.checkModel.checkDate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            togglecheckDatePicker() {
                this.$refs.checkDate.togglePicker();
            },
            onCreateendDatePicked(val) {
                this.newendDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.reciptModel.endDate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateendDatePicker() {
                this.$refs.endDate.togglePicker();
            },
            onProfileGenderChange(val) {
                if (val && val.value !== undefined) {
                    this.reciptModel.male = val.value;
                }
            },

            onStartDatePicked(val) {
                this.newpayRepstartDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.taxModel.startDate = this.jalaliToGregorian(val);
                if (this.taxModel.endDate !== "") {
                    this.getMyreciptsByDate();
                }
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/

            },
            toggleStartDatePicker() {
                this.$refs.paystartDate.togglePicker();
            },
            onEndDatePicked(val) {
                this.newpayRependDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.taxModel.endDate = this.jalaliToGregorian(val);
                if (this.taxModel.startDate !== "") {
                    this.getMyreciptsByDate();
                }
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleEndDatePicker() {
                this.$refs.payendDate.togglePicker();
            },

            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("recipt", `/Searchrecipt/${this.search}`).getList().then(response => {
                        this.myrecipts = response.data;
                        for (let it of this.myrecipts) {
                            it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMyrecipts();
                }
            },
            searchingId() {

                this.isLoading = false;
                new BaseService("recipt", `/GetReciptByBuyId/${this.searchId}`).getList().then(response => {
                    this.myrecipts = response.data;
                    for (let it of this.myrecipts) {
                        it.fDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    }
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });

            },
            searchingcustomer() {
                if (this.searchcustomerBuy.length > 2) {
                    new BaseService("customer", `/searchcustomerBuy/${this.search}`).getList().then(response => {
                        this.customerBuys = response.data;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getcustomerBuys();
                }
            },
            searchingengineer() {
                if (this.searchEngineer.length > 2) {
                    new BaseService("EngineerContract", `/SearchEngineerContract/${this.search}`).getList().then(response => {
                        this.engineers = response.data;
                        for (let it of this.engineers) {
                            it.fsDate = Moment(this.gregorianToJalali(it.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.feDate = Moment(this.gregorianToJalali(it.endDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getengineers();
                }
            },
            selectItem(it) {
                this.customerBuyName = it.product.name;
                this.customerFullname = it.customer.fullName;
                this.customerBuyprice = it.price;
                this.customerBuyremain = it.remain;
                this.reciptModel.customerBuyId = it.id;
                this.reciptModel.price = it.remain;
                console.log(this.reciptModel)

            },
            // searchingcontract() {
            //     if (this.searchcontract.length > 2) {
            //         new BaseService("contract", `/Searchcontract/${this.searchcontract}`).getList().then(response => {
            //             this.contracts = response.data;
            //
            //         }).catch(error => {
            //             Utils.handleErrorWithNotification(error.data, this.$noty);
            //         });
            //     } else {
            //         this.getcontracts();
            //     }
            // },
            // getcontracts() {
            //     new BaseService("contract", `/GetPayRecContract/${true}`).getList().then(response => {
            //         this.contracts = response.data;
            //
            //     }).catch(error => {
            //         console.log(error);
            //         Utils.handleErrorWithNotification(error.data, this.$noty);
            //     });
            // },
            selectcontract(it) {
                this.contractName = it.name;
                this.contractDis = it.description;

                this.contractId = it.id;
            },
            thousandSeprator(a) {
                let amount = this.reciptModel.price;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.reciptModel.showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.reciptModel.showprice = amount;
                }
            },


        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>